import { ModalSize } from '../../services/modal/mvd-modal.enum';
import { MvdModalService } from '../../services/modal/mvd-modal.service';
import { SharedConfirmData } from './confirmation-data.model';

export class SharedAlertData extends SharedConfirmData {
    public dTitle = 'Alert';
    public dOkBtnText = 'OK';

    constructor(caller: MvdModalService = undefined) {
        super(caller);
    }

    // open modal to size (optional)
    open(size?: ModalSize) {
        return this.caller.alertModal(this, size);
    }
}
